import { useState } from "react";
import { useDispatch } from "react-redux";
import ErrorText from "../../../components/Typography/ErrorText";
import { showNotification } from "../../common/headerSlice";
import api from "../../../utils/axios";
import { triggerRefresh } from "../../../utils/refreshRegistry";

function DeleteServiceRoleModalBody({ closeModal, extraObject }) {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [deleting, setDeleting] = useState(false);

  const deleteRole = async () => {
    setDeleting(true);
    setErrorMessage("");

    try {
      await api.delete(`/api/service-roles/${extraObject.id}`);
      dispatch(showNotification({ message: "Service Role Deleted!", status: 1 }));
      closeModal();
      triggerRefresh("service-roles");
    } catch (error) {
      console.error("Error deleting service role:", error);
      const errorMsg =
        error.response?.data?.message ||
        "Failed to delete service role. Please try again.";
      setErrorMessage(errorMsg);
      dispatch(showNotification({ message: errorMsg, status: 0 }));
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <p className="mt-4">
        Are you sure you want to delete the service role <strong>"{extraObject?.name}"</strong>?
        This will also delete all associated assignments.
      </p>

      <ErrorText styleClass="mt-4">{errorMessage}</ErrorText>
      <div className="modal-action">
        <button className="btn btn-ghost" onClick={() => closeModal()}>
          Cancel
        </button>
        <button
          className="btn btn-error px-6"
          onClick={deleteRole}
          disabled={deleting}
        >
          {deleting ? (
            <>
              <span className="loading loading-spinner loading-sm"></span>
              Deleting...
            </>
          ) : (
            "Delete"
          )}
        </button>
      </div>
    </>
  );
}

export default DeleteServiceRoleModalBody;